var _class;
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import { AbIcon } from "abreact/misc/AbIcon";
import { observer } from "mobx-react";
import * as React from "react";
export let LocalValidationErrorIcon = observer(_class = class LocalValidationErrorIcon extends React.Component {
  render() {
    const className = CssUtils.composeClassNames("guided-expression-editor-input-local-validation-error-icon", this.props.className);
    return /*#__PURE__*/React.createElement(AbIcon, {
      className: className,
      style: {
        cursor: this.props.onClick != null ? "pointer" : undefined
      },
      image: "absdk:error",
      tooltip: this.props.tooltip,
      onClick: this.props.onClick
    });
  }
}) || _class;
//# sourceMappingURL=LocalValidationErrorIcon.js.map
